{
	"title": "Aviso legal",
	"backTitle": "Atrás",
	"company": {
		"name": "HDigital GmbH",
		"address": {
			"street": "Berliner Straße 6",
			"city": "69120 Heidelberg",
			"country": "Alemania"
		},
		"contact": {
			"telephone": "Teléfono: +49 6221 481-0",
			"telefax": "Telefax: +49 6221 481-13553",
			"email": "Correo electrónico: info@heidelbergmaterials.com"
		},
		"legal": {
			"registeredOffice": "Domicilio social de la empresa: Heidelberg",
			"commercialRegister": "Registro mercantil: Mannheim, HRB 741878",
			"managingDirectors": "Directores Generales:",
			"directors": {
				"rene": "René Aldach",
				"roland": "Roland Sterr",
				"noman": "Noman Ahmed"
			}
		}
	}
}
